import * as React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client'
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { App } from 'App';
import theme from 'theme';
import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from 'Auth';
import { ModalProvider } from 'Modals';
import { DrawerProvider } from 'Drawer';
import { AppProvider } from 'App/AppContext';
import { SnackbarProvider } from 'Components/Snackbar';
import packageJson from '../package.json';
import { CartProvider } from 'Contexts/Cart';
import './output.css'
import registerServiceWorker from './serviceWorker';
import { NotificationsProvider } from 'Contexts/Notifications';


global.appVersion = packageJson.version;

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter basename="/" future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <SnackbarProvider>
      <AppProvider>
        <AuthProvider>
          <DrawerProvider>
            <ModalProvider>
              <CartProvider>
                <NotificationsProvider>
                  <ThemeProvider theme={theme}>
                    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
                    <CssBaseline />
                    <App />
                  </ThemeProvider>
                </NotificationsProvider>
              </CartProvider>
            </ModalProvider>
          </DrawerProvider>
        </AuthProvider>
      </AppProvider>
    </SnackbarProvider>
  </BrowserRouter>
)

registerServiceWorker()
